import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import {
  getTransportAuctionsPageParamsForCalendarsSchema,
  getTransportAuctionsPageParamsForComfortBidsSchema,
  getTransportAuctionsPageParamsForReverseAuctionsSchema,
  schedulesPageParamsSchema,
} from 'src/pages/transport/auctions/schema';

export function useTransportAuctionsPageParams() {
  const calendars = usePageParamsFromSchema(
    getTransportAuctionsPageParamsForCalendarsSchema(),
    {
      groupPrefix: 'calendars',
      filters: {
        publicationDate: { label: 'Publication Date' },
        publicationDateEnd: { label: 'Publication Date' },
        auctionStartDate: { label: 'Auction Start' },
        auctionStartDateEnd: { label: 'Auction Start End' },
        productRuntimeStart: { label: 'Product Runtime Start' },
        productRuntimeEnd: { label: 'Product Runtime End' },
        capacityCategory: { label: 'Capacity Types' },
      },
    }
  );

  const reverseAuctions = usePageParamsFromSchema(
    getTransportAuctionsPageParamsForReverseAuctionsSchema(),
    {
      groupPrefix: 'reverseAuctions',
    }
  );

  const comfortBids = usePageParamsFromSchema(
    getTransportAuctionsPageParamsForComfortBidsSchema(),
    {
      groupPrefix: 'comfortBids',
    }
  );

  const schedules = usePageParamsFromSchema(schedulesPageParamsSchema, {
    groupPrefix: 'schedules',
    filters: {
      publicationDateStart: { label: 'Publication Date' },
      publicationDateEnd: { label: 'Publication Date' },
      openDateStart: { label: 'Auction Start' },
      openDateEnd: { label: 'Auction Start' },
      runtimeIntersectionFilterStart: { label: 'Runtimes' },
      runtimeIntersectionFilterEnd: { label: 'Runtimes' },
      slotIndex: { label: 'Slot' },
    },
  });

  return { calendars, reverseAuctions, comfortBids, schedules };
}

export type TransportAuctionsPageParams = ReturnType<
  typeof useTransportAuctionsPageParams
>;
